import { useEffect, useRef } from "react";
import { HALLS } from "@/lib/areas";

// Approx geo coords for the 3 hall addresses (Sunshine Coast QLD)
const COORDS = {
  mudjimba: { lat: -26.6260, lng: 153.0922 },  // 41 Cottonwood St, Mudjimba
  kawana:   { lat: -26.6883, lng: 153.1330 },  // 58 Illuka Ave, Buddina
  eudlo:    { lat: -26.7423, lng: 152.9573 },  // 19 Rosebed St, Eudlo
};

export default function HallsMap() {
  const mapRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const L = (await import("leaflet")).default;
      await import("leaflet/dist/leaflet.css");
      if (cancelled || !mapRef.current || instanceRef.current) return;

      const map = L.map(mapRef.current, { scrollWheelZoom: false }).setView([-26.685, 153.05], 11);
      instanceRef.current = map;

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19,
      }).addTo(map);

      // Custom orange pin
      const pin = L.divIcon({
        className: "pp-pin",
        html: '<div style="width:28px;height:28px;border-radius:50% 50% 50% 0;background:#f38838;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.3);transform:rotate(-45deg);"></div>',
        iconSize: [28, 28],
        iconAnchor: [14, 28],
        popupAnchor: [0, -28],
      });

      Object.entries(HALLS).forEach(([key, h]) => {
        const c = COORDS[key];
        if (!c) return;
        L.marker([c.lat, c.lng], { icon: pin })
          .addTo(map)
          .bindPopup(
            `<div style="font-family:'Outfit',sans-serif"><strong style="color:#1b4a76;font-size:14px">${h.name}</strong><br/><span style="font-size:12px;color:#57534e">${h.address}</span><br/><span style="font-size:11px;color:#f38838;font-weight:600;text-transform:uppercase;letter-spacing:0.05em">${h.times}</span></div>`
          );
      });
    })();

    return () => {
      cancelled = true;
      if (instanceRef.current) {
        instanceRef.current.remove();
        instanceRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={mapRef}
      data-testid="halls-map"
      className="w-full h-[420px] rounded-2xl border border-stone-200 overflow-hidden z-0"
      style={{ background: "#e7e5e4" }}
    />
  );
}
